import React from "react";
import type { UniquePageProps } from "@admin/pages/UniquePageEditor";
import { AboutPageModel } from "@admin/domain/uniquePages/models/AboutPageModel";
import FileInput from "@admin/components/FileInput";
import MultiLanguages from "@admin/components/MultiLanguage";
import { Language } from "@admin/domain/languages/helpers";
import Input from "@admin/components/Input";

export default function AboutPageDownloadLinks({ page }: UniquePageProps<AboutPageModel>) {
    return (
        <div className="mb-10">
            <h4 className="mb-5">Ссылки для скачивания</h4>

            <div className="row">
                <div className="rounded border p-6 mb-5 col">
                    <MultiLanguages
                        languageElement={(language: Language) => (
                            <Input
                                label="Название ссылки"
                                name={`content[download_link_one__title][${language}]`}
                                defaultValue={page.contentObject.download_link_one__title?.[language]}
                            />
                        )}
                    />

                    <FileInput
                        name="content[download_link_one][file_id]"
                        label="Файл для скачивания"
                        defaultValue={page.contentObject.download_link_one__file}
                    />
                </div>

                <div className="rounded border p-6 mb-5 col">
                    <MultiLanguages
                        languageElement={(language: Language) => (
                            <Input
                                label="Название ссылки"
                                name={`content[download_link_two__title][${language}]`}
                                defaultValue={page.contentObject.download_link_two__title?.[language]}
                            />
                        )}
                    />

                    <FileInput
                        name="content[download_link_two][file_id]"
                        label="Файл для скачивания"
                        defaultValue={page.contentObject.download_link_two__file}
                    />
                </div>
            </div>
        </div>
    );
}
